<template>
  <div class="card">
    <div class="card-body">
      <h4 class="card-title mb-2" style="text-transform: capitalize">
        {{ timespan }}ly Profit
      </h4>
      <div class="row">
        <div class="col-sm-6">
          <p class="text-muted">{{ month }}</p>
          <h3>${{ (totalRevenue - totalExpenses).toFixed(2) }}</h3>

          <div class="mt-4">
            <button
              @click="
                () => {
                  viewMore = !viewMore;
                }
              "
              class="btn btn-primary btn-sm"
            >
              View More
              <i class="mdi mdi-arrow-right ml-1"></i>
            </button>
          </div>
        </div>

        <div class="col-sm-6">
          <!-- Chart -->
          <apexchart
            class="apex-charts"
            dir="ltr"
            height="140"
            :series="series"
            :options="chartOptions"
          ></apexchart>
        </div>
        <div v-if="viewMore" class="col-md">
          <h4 class="mt-3">
            Revenue: $<span style="color: green">{{
              this.totalRevenue.toFixed(2)
            }}</span>
            <b-button
              @click="
                () => {
                  showRevenue = !showRevenue;
                }
              "
              class="ml-3"
              variant="primary"
              size="sm"
              ><i class="mdi mdi-chevron-down"></i
            ></b-button>
          </h4>
          <div v-if="showRevenue" class="ml-3">
            <h5>
              Labour: $<span>{{ payrollRevenue.toFixed(2) }}</span>
            </h5>
            <h5>
              Products: $<span>{{ productRevenue.toFixed(2) }}</span>
            </h5>
            <h5>
              Fixed Rate Jobs: $<span>{{
                fixedRateJobRevenue.toFixed(2)
              }}</span>
            </h5>
            <h5>
              Procurements: $<span>{{ procurementRevenue.toFixed(2) }}</span>
            </h5>
            <div class="ml-3">
              <p class="mb-1">
                Materials: ${{
                  this.procurementRevenueBreakdown['Materials'].toFixed(2)
                }}
              </p>
              <p class="mb-1">
                Rentals: ${{
                  this.procurementRevenueBreakdown['Rentals'].toFixed(2)
                }}
              </p>
              <p class="mb-1">
                3rd Party: ${{
                  this.procurementRevenueBreakdown['3rd Party'].toFixed(2)
                }}
              </p>
              <p class="mb-1">
                Other: ${{
                  this.procurementRevenueBreakdown['Other'].toFixed(2)
                }}
              </p>
            </div>
          </div>

          <h4 class="mt-3">
            Expenses: $<span style="color: red">{{
              this.totalExpenses.toFixed(2)
            }}</span
            ><b-button
              @click="
                () => {
                  showExpense = !showExpense;
                }
              "
              class="ml-3"
              variant="primary"
              size="sm"
              ><i class="mdi mdi-chevron-down"></i
            ></b-button>
          </h4>
          <div v-if="showExpense" class="ml-3">
            <h5>
              Payroll: $<span>{{ payrollExpenses.toFixed(2) }}</span>
            </h5>
            <h5>
              Products: $<span>{{ productExpenses.toFixed(2) }}</span>
            </h5>
            <h5>
              Procurements: $<span>{{ procurementExpenses.toFixed(2) }}</span>
            </h5>
            <div class="ml-3">
              <p class="mb-1">
                Materials: ${{
                  this.procurementExpensesBreakdown['Materials'].toFixed(2)
                }}
              </p>
              <p class="mb-1">
                Rentals: ${{
                  this.procurementExpensesBreakdown['Rentals'].toFixed(2)
                }}
              </p>
              <p class="mb-1">
                3rd Party: ${{
                  this.procurementExpensesBreakdown['3rd Party'].toFixed(2)
                }}
              </p>
              <p class="mb-1">
                Other: ${{
                  this.procurementExpensesBreakdown['Other'].toFixed(2)
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Monthly-Earning component
 */
import Vue from 'vue';
import firebase from 'firebase';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

export default {
  props: {
    month: String,
    timespan: String,
    total: String,
    chartColor: String,
    billableTimes: Array,
    billableProducts: Array,
    billableProcurements: Array,
    fixedRateJobRevenue: Number,
    fixedRateJobs: Array,
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          type: 'donut',
          height: 140,
        },
        labels: ['Labour', 'Products', 'Procurements', 'Fix Rate Job Revenue'],
        colors: ['#556ee6', '#34c38f', '#f46a6a'],
        legend: {
          show: false,
        },
        plotOptions: {
          pie: {
            donut: {
              size: '60%',
            },
          },
        },
      },
      payrollExpenses: null,
      productExpenses: null,
      procurementExpenses: null,
      totalExpenses: null,
      payrollRevenue: null,
      productRevenue: null,
      procurementRevenue: null,
      totalRevenue: null,
      viewMore: false,
      showRevenue: false,
      showExpense: false,
      procurementRevenueBreakdown: {
        Materials: 0,
        Rentals: 0,
        '3rd Party': 0,
        Other: 0,
      },
      procurementExpensesBreakdown: {
        Materials: 0,
        Rentals: 0,
        '3rd Party': 0,
        Other: 0,
      },
    };
  },
  methods: {
    getTotalExpenses: async function() {
      try {
        this.payrollExpenses = 0;
        this.productExpenses = 0;
        this.procurementExpenses = 0;
        this.totalExpenses = 0;
        const uniqueUsers = new Set();
        let userRates = {};
        let promises = [];

        //loop all of the billable times and get a list of users that have submitted time this month.
        this.billableTimes.forEach((time) => {
          uniqueUsers.add(time.employeeID);
        });

        //loop the unique users and get their payroll rates and overtime rates.
        uniqueUsers.forEach((user) => {
          try {
            let db = firebase.firestore();
            let page = db.collection('employees').doc(user);
            promises.push(
              page.get().then((doc) => {
                //only add the employee if they exist in the database. In other words, don't add users that have been deleted.
                if (doc.exists) {
                  userRates[user] = {
                    uid: user,
                    payrollRate: doc.data().payrollRate,
                    payrollOvertimeRate: doc.data().payrollOvertimeRate,
                  };
                }
              })
            );
          } catch (error) {
            console.log(error);
          }
        });

        console.log(userRates);
        //once all of the requests for rates complete, loop the times and start applying payroll expenses based on which user submitted the time.
        await Promise.all(promises).then(() => {
          this.billableTimes.forEach((time) => {
            //check to see if the user is not deleted.
            if (userRates[time.employeeID]) {
              // console.log(time.hours);

              //if the time is marked as overtime, use the employees overtime rate for the expense.
              if (time.overtime) {
                this.payrollExpenses +=
                  Number(time.hours) *
                  (Number(userRates[time.employeeID].payrollOvertimeRate)
                    ? Number(userRates[time.employeeID].payrollOvertimeRate)
                    : 0);
              } else {
                this.payrollExpenses +=
                  Number(time.hours) *
                  (Number(userRates[time.employeeID].payrollRate)
                    ? Number(userRates[time.employeeID].payrollRate)
                    : 0);
              }
            }
          });
        });

        this.billableProcurements.forEach((procurement) => {
          this.procurementExpenses += Number(
            procurement.receivedAmount
              ? procurement.receivedAmount
              : procurement.quotedAmount
          );
          //if the procurement doesn't have a type, include it in other.
          //this shouldn't be an issue in the future, as type is now a required field for adding/editing procurements.
          this.procurementExpensesBreakdown[
            procurement.type ? procurement.type : 'Other'
          ] += Number(
            procurement.receivedAmount
              ? procurement.receivedAmount
              : procurement.quotedAmount
          );
        });
        this.billableProducts.forEach((product) => {
          this.productExpenses += Number(
            product.price ? product.price * product.quantity : 0
          );
        });
        this.totalExpenses =
          this.payrollExpenses +
          this.productExpenses +
          this.procurementExpenses;
      } catch (err) {
        console.log(err);
        Vue.$toast.open({
          message: 'Error calculating expenses in dashboard profit component.',
          type: 'error',
          duration: 4000,
          position: 'top-right',
        });
      }
    },
    getTotalRevenue: function() {
      try {
        this.payrollRevenue = 0;
        this.productRevenue = 0;
        this.procurementRevenue = 0;
        this.totalRevenue = 0;

        //filter out all of the billable times, products, and procurements, so revenue will only calculatea off of non-quoted jobs.
        let tempBillableTimes = this.billableTimes.filter((time) =>
          time.billable !== true && this.fixedRateJobs.length >= 1
            ? this.fixedRateJobs.some((o) => o.jobNum != time.jobNum)
            : true
        );

        tempBillableTimes.forEach((time) => {
          this.payrollRevenue += time.total;
        });

        let tempBillableProducts = this.billableProducts.filter((time) =>
          time.billable !== true && this.fixedRateJobs.length >= 1
            ? this.fixedRateJobs.some((o) => o.jobNum != time.jobNum)
            : true
        );

        tempBillableProducts.forEach((product) => {
          this.productRevenue +=
            Number(product.quantity) * Number(product.rate);
        });

        let tempBillableProcurements = this.billableProcurements.filter(
          (time) =>
            time.billable !== true && this.fixedRateJobs.length >= 1
              ? this.fixedRateJobs.some((o) => o.jobNum != time.jobNum)
              : true
        );

        tempBillableProcurements.forEach((procurement) => {
          //only sum the revenue if the procurement item has a received amount.
          if (procurement.receivedAmount) {
            if (
              procurement.markup !== null &&
              procurement.markup !== undefined &&
              procurement.markup !== ''
            ) {
              if (procurement.markupType === 'flatRate') {
                this.procurementRevenue += Number(procurement.markup);

                this.procurementRevenueBreakdown[procurement.type] += Number(
                  procurement.markup
                );
              } else if (procurement.markupType === 'dollar') {
                this.procurementRevenue +=
                  Number(procurement.receivedAmount) +
                  Number(procurement.markup);

                this.procurementRevenueBreakdown[procurement.type] +=
                  Number(procurement.receivedAmount) +
                  Number(procurement.markup);
              } else if (procurement.markupType === 'percentage') {
                this.procurementRevenue +=
                  Number(procurement.receivedAmount) *
                    (Number(procurement.markup) / 100) +
                  Number(procurement.receivedAmount);

                this.procurementRevenueBreakdown[procurement.type] +=
                  Number(procurement.receivedAmount) *
                    (Number(procurement.markup) / 100) +
                  Number(procurement.receivedAmount);
              }
            }
            //if the procurement item has a received amount, but not a markup, include it in the revenue.
            else {
              this.procurementRevenue += Number(procurement.receivedAmount);

              this.procurementRevenueBreakdown[procurement.type] += Number(
                procurement.receivedAmount
              );
            }
          }
        });
        this.totalRevenue =
          this.payrollRevenue +
          this.productRevenue +
          this.procurementRevenue +
          this.fixedRateJobRevenue;

        //set the chart values.
        this.series = [
          this.payrollRevenue,
          this.productRevenue,
          this.productRevenue,
          this.fixedRateJobRevenue,
        ];
      } catch (err) {
        console.log(err);
        Vue.$toast.open({
          message: 'Error calculating revenue in dashboard profit component.',
          type: 'error',
          duration: 4000,
          position: 'top-right',
        });
      }
    },
  },
  mounted() {
    this.getTotalExpenses();
    this.getTotalRevenue();
  },
};
</script>
